import {
  CSSProperties,
  useRef,
  FC,
  Fragment,
  useLayoutEffect,
  useState,
} from 'react';
import { get, noop } from 'lodash';

import classNames from 'classnames';
import { useTheme } from 'styled-components';

import { FormPlainVariant } from '../FormPlain.types';

import { FONT_SIZE_MAPPING, LINE_HEIGHT_MAPPING } from './FormPlainInput.const';

import styles from './FormPlainInput.module.scss';

interface FormPlainInputProps {
  value: string;
  autofocus?: boolean;
  onBlur: () => void;
  placeholder?: string;
  variant: FormPlainVariant;
  onChange: (...args: any) => void;
}

export const FormPlainInput: FC<FormPlainInputProps> = ({
  value,
  variant,
  placeholder,
  onBlur,
  onChange,
}) => {
  const { fontSize } = useTheme();
  const ref = useRef<HTMLTextAreaElement>();
  const mirror = useRef<HTMLTextAreaElement>();
  const [height, setHeight] = useState(0);

  const style: CSSProperties = {
    fontSize: fontSize(FONT_SIZE_MAPPING[variant]),
    lineHeight: fontSize(LINE_HEIGHT_MAPPING[variant]),
  };

  useLayoutEffect(() => {
    const observer = new MutationObserver(([{ target }]) => {
      setHeight(() => get(target, 'scrollHeight', 0));
    });

    setTimeout(() => setHeight(() => mirror.current.scrollHeight), 100);

    observer.observe(mirror.current, {
      attributes: true,
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);

  return (
    <Fragment>
      <textarea
        ref={ref}
        value={value}
        onBlur={onBlur}
        onChange={onChange}
        placeholder={placeholder}
        style={{ ...style, height }}
        className={classNames(styles.input, styles[variant])}
      />
      <textarea
        ref={mirror}
        style={style}
        value={value}
        onBlur={onBlur}
        onChange={noop}
        placeholder={placeholder}
        className={classNames(styles.input, styles[variant], styles.mirror)}
      />
    </Fragment>
  );
};
